// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3O87Y","item":"PaymentsMobile_item__2lJ1O","label":"PaymentsMobile_label__2dbYQ","amount":"PaymentsMobile_amount__2y39q"};